import React, { Component } from "react";
import PropTypes from "prop-types";

// Components
import PayinBillingDetails from "./PayinBillingDetails";
import PayinConfirm from "./PayinConfirm";
import PayinMethods from "./PayinMethods";
import MandateConfirm from "./MandateConfirm";

class PayinForm extends Component {
  static propTypes = {
    initialValues: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  render() {
    const { page } = this.state;
    const { initialValues } = this.props;

    return (
      <div>
        {page === 1 && (
          // <MandateConfirm
          //   previousPage={this.previousPage}
          //   onSubmit={this.nextPage}
          //   initialValues={initialValues}
          // />
          <PayinMethods
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
            initialValues={initialValues}
          />
        )}

        {page === 2 && (
          <PayinBillingDetails
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
            initialValues={initialValues}
          />
        )}
        {page === 3 && (
          <PayinConfirm
            previousPage={this.previousPage}
            onSubmit={this.nextPage}
            initialValues={initialValues}
          />
        )}
      </div>
    );
  }
}

export default PayinForm;
